const blog = [
    {
        "id": 101,
        "icon": [require('../images/ICON/Group 204.png'), require('../images/ICON/bus.png')],
        "image": require('../images/img/blog1.png'),
        "title": "Quick Delivery",
        "description": "For a memorable meal the quality of the service is something that guests often remember. Restaurant provides a physical good (prepared food), but also provides services in the form of ambience, the setting and clearing of the table, etc."
    },
    {
        "id": 102,
        "icon": [require('../images/ICON/Group 1133.png'), require('../images/ICON/notification.png')],
        "image": require('../images/img/blog2.png'),
        "title": "A Good Auto Responder",
        "description": "For a memorable meal the quality of the service is something that guests often remember. Restaurant provides a physical good (prepared food), but also provides services in the form of ambience, the setting and clearing of the table, etc."
    },
    {
        "id": 103,
        "icon": [require('../images/ICON/Group 245.png'), require('../images/ICON/car.png')],
        "image": require('../images/img/blog3.png'),
        "title": "Home Delivery",
        "description": "For a memorable meal the quality of the service is something that guests often remember. Restaurant provides a physical good (prepared food), but also provides services in the form of ambience, the setting and clearing of the table, etc."
    }
]

export default blog;